import React from 'react';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import Panel from 'Components/Panel/Panel';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';

const NoScreensAllowed = () => {
    return (
        <LayoutDefault>
            <Panel className={'main-modal'} style={{ display: 'flex', flexDirection: 'column' }}>
                <h1 style={{ maxWidth: '760px', textAlign: 'center', margin: '10vh auto 0px auto', padding: '0px 24px', fontSize: 'clamp(1.2rem, 2.4vw, 2rem)', color: 'var(--color-text)', minHeight: 'calc(30% - 10vh)' }}>
                    Ainda não há telas disponíveis para o seu usuário. Por favor, entre em contato com o administrador para mais informações.
                </h1>
                <PanelListDefault
                    idsSelected={[]}
                    data={[]}
                    isEmptyPanel={true}
                    style={{ width: '100%', height: '70%' }}
                />
            </Panel>
        </LayoutDefault >
    );
};

export default NoScreensAllowed;